/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { View, Icon, Text } from '@az/starc-ui';
import { StarWhole } from '@az/starc-ui-icons';

const labelMap = {
  verifiedPurchase: 'label_reviews_verifiedPurchase',
};

export const VerifiedPurchase = () => {
  const labels = useLabels(labelMap);

  return (
    <View className={styles.badgeContainer}>
      <Icon svg={StarWhole} color="accent" size={{ s: 3.75, m: 4 }} />
      <Text variant="small-body" weight="bold">
        {labels.verifiedPurchase}
      </Text>
    </View>
  );
};
